module.exports = __webpack_public_path__ + "img/manor-myone-card.66731b93.png";